import { createContext } from 'react';
import { OrderFormContextValues } from './types/OrderFormContextValues';

const OrderFormContext = createContext<OrderFormContextValues | undefined>(undefined);

export const OrderFormProvider = OrderFormContext.Provider;

export default OrderFormContext;
